export default __webpack_public_path__ + "static/media/photo--sm--132.66582d06.jpg";